import React, { useState, useEffect } from 'react';
import { FormControlLabel, RadioGroup, Radio, Typography  } from "@material-ui/core";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    customTypography: {
      fontFamily: 'FTPolar-Light',
    },
  }));

export default function Septic(props) {
    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();
        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }

    useEffect(()=>{
        if(props?.partner?.url_path === "c2"){
            const h2Tags = document.querySelectorAll('h2');
            const h4Tags = document.querySelectorAll('h4');
            const h6Tags = document.querySelectorAll('h6');
            const spanTags = document.querySelectorAll('span');
            const a = document.querySelectorAll('a');
              h2Tags.forEach(h2 => {
                h2.classList.add('ftpolar-semibold');
              });
              h4Tags.forEach(h4 => {
                h4.classList.add('ftpolar-semibold');
              });
              h6Tags.forEach(h6 => {
                h6.classList.add('ftpolar-semibold');
              });
              spanTags.forEach(span => {
                span.classList.add('ftpolar-light');
              });
              a.forEach(a => {
                a.classList.add('ftpolar-light');
              });
        }
        },[props.pageNumber,props.submitResponse])



    return (
        <div className="form-question">
            <div className="form-content" id="ready_to_sell">
                <h4 className="form-content-heading m-0">
                    Does your home have a septic system?
                </h4>
                <div className="py-2">
                    <RadioGroup
                        row 
                        name="septic"
                        value={props.values.septic}
                        onChange={props.handleChange}
                    >
                        <div>
                            <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                        </div>
                        <div>
                            <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                        </div>
                    </RadioGroup>
                </div>
            </div>
        </div>
    )
}
